import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { CellButton } from './styled';
import { Cell } from '../styled';
const ClickableButton = styled(CellButton).withConfig({ displayName: "vui--ClickableButton", componentId: "vui--oqo38u" }) `color:${theme.text.link.color};text-decoration:${theme.text.link.textDecoration};`;
export const ClickableCell = (_a) => {
    var { onClick, children } = _a, otherProps = __rest(_a, ["onClick", "children"]);
    return (React.createElement(Cell, Object.assign({}, otherProps),
        React.createElement(ClickableButton, { onClick: onClick }, children)));
};
//# sourceMappingURL=ClickableCell.js.map